export default {
    TOGGLE_EDIT_MODAL (state, data) {
        state.qualityAssuranceModal.isOpen = data.open;
        state.qualityAssuranceModal.editingId = data.id;

        if (data.open === true) {
            return;
        }

        state.qualityAssuranceModal.autocomplete.projectsSearchTerm = '';
        state.qualityAssuranceModal.autocomplete.ordersSearchTerm = '';
        state.qualityAssuranceModal.autocomplete.test_types.splice(0, state.qualityAssuranceModal.autocomplete.test_types.length);
        state.qualityAssuranceModal.autocomplete.statuses.splice(0, state.qualityAssuranceModal.autocomplete.statuses.length);
        state.qualityAssuranceModal.autocomplete.projects.splice(0, state.qualityAssuranceModal.autocomplete.projects.length);
        state.qualityAssuranceModal.autocomplete.orders.splice(0, state.qualityAssuranceModal.autocomplete.orders.length);
        state.qualityAssuranceModal.errors = {};

        let keys = Object.keys(state.qualityAssuranceModal.data);
        for (let i = 0; i < keys.length; i++) {
            if (Array.isArray(state.qualityAssuranceModal.data[keys[i]])) {
                state.qualityAssuranceModal.data[keys[i]] = [];
            } else {
                if (keys[i] == 'water_test_allowable') {
                    state.qualityAssuranceModal.data[keys[i]] = 'No Leakage';
                } else if (keys[i] == 'air_test_allowable') {
                    state.qualityAssuranceModal.data[keys[i]] = '0.15';
                } else if (keys[i] == 'passed' || keys[i] == 'qr_code' || keys[i] == 'position') {
                    state.qualityAssuranceModal.data[keys[i]] = null;
                } else {
                    state.qualityAssuranceModal.data[keys[i]] = '';
                }
            }
        }
    },
    SET_EDIT_MODAL_PROJECTS (state, projects) {
        state.qualityAssuranceModal.autocomplete.projects.splice(0, state.qualityAssuranceModal.autocomplete.projects.length, ...projects);
    },
    SET_EDIT_MODAL_ORDERS (state, orders) {
        state.qualityAssuranceModal.autocomplete.orders.splice(0, state.qualityAssuranceModal.autocomplete.orders.length, ...orders);
    },
    SET_EDIT_MODAL_DATA (state, data) {
        let keys = Object.keys(data);

        for (let i = 0; i < keys.length; i++) {
            state.qualityAssuranceModal.data[keys[i]] = data[keys[i]];
        }
    },
    SET_CREATION_INFO (state, data) {
        state.qualityAssuranceModal.autocomplete.test_types.splice(0, state.qualityAssuranceModal.autocomplete.test_types.length, ...data.test_types);
        state.qualityAssuranceModal.autocomplete.statuses.splice(0, state.qualityAssuranceModal.autocomplete.statuses.length, ...data.statuses);
    },
    SET_EDIT_MODAL_ERRORS (state, data) {
        state.qualityAssuranceModal.errors = data;
    },
    TOGGLE_LIST_REFRESH (state, data) {
        state.qualityAssuranceList.refreshList = data;
    },
    SET_FILTERS_INFO (state, data) {
        state.qualityAssuranceList.filterData.test_types.splice(0, state.qualityAssuranceList.filterData.test_types.length, ...data.test_types);
        state.qualityAssuranceList.filterData.statuses.splice(0, state.qualityAssuranceList.filterData.statuses.length, ...data.statuses);
    },
    SET_FILTERS_DATA (state, data) {
        let keys = Object.keys(data);

        for (let i = 0; i < keys.length; i++) {
            if (Array.isArray(data[keys[i]])) {
                state.qualityAssuranceList.filters[keys[i]].splice(0, state.qualityAssuranceList.filters[keys[i]].length, ...data[keys[i]]);
            } else {
                if (keys[i] === 'filter') {
                    let filter = data[keys[i]];
                    if ((filter instanceof String || typeof filter == 'string') && filter.length > 200) {
                        filter = filter.substring(0, 200);
                    }
                    state.qualityAssuranceList.filters[keys[i]] = filter;
                } else {
                    state.qualityAssuranceList.filters[keys[i]] = data[keys[i]];
                }
            }
        }
    },
    TOGGLE_FILTER_SIDEBAR (state, data) {
        state.qualityAssuranceList.filtersOpen = data;
    },
    REMOVE_FILTER (state, data) {
        let field;
        if (data.data_type === 'Enums\\QualityAssuranceTestType') {
            field = 'test_type';
        } else if (data.data_type === 'Enums\\QualityAssuranceStatus') {
            field = 'status'
        } else {
            field = 'passed';
        }
        for (let i = 0; i < state.qualityAssuranceList.filters[field].length; i++) {
            if (data.data_type === 'Enums\\QualityAssuranceTestType') {
                if (state.qualityAssuranceList.filters.test_type[i].name === data.name) {
                    state.qualityAssuranceList.filters.test_type.splice(i, 1);
                }
            } else if (data.data_type === 'Enums\\QualityAssuranceStatus') {
                if (state.qualityAssuranceList.filters.status[i].name === data.name) {
                    state.qualityAssuranceList.filters.status.splice(i, 1);
                }
            } else {
                if (state.qualityAssuranceList.filters.passed[i].value === data.value) {
                    state.qualityAssuranceList.filters.passed.splice(i, 1);
                }
            }
        }
    },
    TOGGLE_ACTION_WITH_REASON (state, data) {
        if (data.open) {
            state.qualityAssuranceModal.actionWithReason.action = data.action;
            state.qualityAssuranceModal.actionWithReason.isOpen = data.open;

            return;
        }

        state.qualityAssuranceModal.actionWithReason.isOpen = data.open;
        state.qualityAssuranceModal.actionWithReason.action = '';
        state.qualityAssuranceModal.actionWithReason.reason = '';
        state.qualityAssuranceModal.actionWithReason.errors = {};
    },
    SET_ACTION_REASON (state, data) {
        state.qualityAssuranceModal.actionWithReason.reason = data;
    },
    SET_ACTION_ERRORS (state, data) {
        state.qualityAssuranceModal.actionWithReason.errors = data;
    },
    TOGGLE_CONFIRMATION_MODAL (state, data) {
        state.confirmation.isOpen = data.isOpen;
        if (data.isOpen) {
            state.confirmation.title = data.title;
            state.confirmation.text = data.text;
            state.confirmation.accept = data.accept;
            state.confirmation.acceptText = data.acceptText;
            state.confirmation.cancel = data.cancel;
            state.confirmation.cancelText = data.cancelText;
        } else {
            state.confirmation.title = '';
            state.confirmation.text = '';
            state.confirmation.accept = null;
            state.confirmation.acceptText = null;
            state.confirmation.cancel = null;
            state.confirmation.cancelText = null;
        }
    },
    ADD_FILE (state, data) {
        // A hack for uninitialized field
        if (data.file !== null) {
            state.qualityAssuranceModal.data[data.field].push(data.file);
        }
    },
    REMOVE_FILE (state, data) {
        state.qualityAssuranceModal.data[data.field].splice(data.fileIndex, 1);
    },
    REMOVE_OLD_POSITION_IMAGES (state, namesToExclude) {
        state.qualityAssuranceModal.data.position_images = state.qualityAssuranceModal.data.position_images.filter(
            file => namesToExclude.indexOf(file.name) <= -1
        )
    },
    SET_PROJECTS_SEARCH_TERM (state, term) {
        state.qualityAssuranceModal.autocomplete.projectsSearchTerm = term;
    },
    SET_ORDERS_SEARCH_TERM (state, term) {
        state.qualityAssuranceModal.autocomplete.ordersSearchTerm = term;
    },
    TOGGLE_QR_READER(state, data) {
        state.qualityAssuranceModal.qrCodeReaderIsOpened = data;
    },
};
